import { normalizeYoutubeEmbedUrl } from '../../../utils/youtube';

export const DEFAULT_WORKSHOP_ASSISTANTS = 1000;

export const createWorkshopSlug = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');

export const createDefaultWorkshopData = () => ({
  title: '',
  slug: '',
  description: '',
  assistants: DEFAULT_WORKSHOP_ASSISTANTS,
  startDate: '',
  image: '',
  recordingLink: '',
  workshopLink: '',
  status: 'inactive',
  hour: '',
  estimatedTime: '',
  receptor: '',
  pillar: '',
  file: '',
});

export const formatDefaultStartDate = () => {
  const date = new Date();
  const pad = (value) => String(value).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const getStartDate = (startDate, hour) => {
  if (startDate && hour) {
    return `${startDate} ${hour}`;
  }

  return startDate || formatDefaultStartDate();
};

export const getPillarId = (pillar) => {
  if (!pillar) {
    return undefined;
  }

  return typeof pillar === 'object' ? pillar.id : pillar;
};

export const getPillarOption = (pillars = [], pillar) => {
  if (!pillar) {
    return '';
  }

  if (typeof pillar === 'object') {
    return pillar;
  }

  return (
    pillars.find((option) => String(option.id) === String(pillar)) || {
      id: pillar,
    }
  );
};

export const mapWorkshopResponseToForm = (workshopData, pillars = []) => {
  const { startDate, ...workshop } = workshopData;
  const date = startDate ? startDate.substring(0, 10) : '';
  const time = startDate ? startDate.substring(11, 16) : '';

  return {
    ...createDefaultWorkshopData(),
    ...workshop,
    hour: time,
    startDate: date,
    pillar: getPillarOption(pillars, workshop.pillar),
  };
};

export const buildWorkshopPayload = (workshopData) => {
  const {
    title,
    slug,
    description,
    assistants,
    startDate,
    status,
    image,
    pillar,
    recordingLink,
    workshopLink,
    hour,
    receptor,
    estimatedTime,
    file,
  } = workshopData;

  return {
    title,
    slug: createWorkshopSlug(slug || title),
    description,
    assistants: Number(assistants) || DEFAULT_WORKSHOP_ASSISTANTS,
    startDate: getStartDate(startDate, hour),
    status,
    image,
    recordingLink: normalizeYoutubeEmbedUrl(recordingLink),
    workshopLink,
    receptor,
    estimatedTime,
    pillar: getPillarId(pillar),
    file,
  };
};
